import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import { ListTable } from 'gnos-tables'
import classnames from 'classnames'
import _ from 'lodash'

import Entity from '../../../../../../../../../../../components/TableCell/components/Entity'
import CustomDate from '../../../../../../../../../../../components/CustomDate'

import { LOCALE_PREFIX } from '../../constants'
import './style.scss'

@injectIntl
export default class Summary extends Component {
    static propTypes = {
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
    }

    render() {
        const { data, id, intl } = this.props

        return (
            <div className={'business-partners-summary'}>
                <ListTable
                    id={`business-partners-summary-table-${id}`}
                    columnsDefinition={{
                        title: {
                            width: 200,
                            Cell: (value) => (
                                <div
                                    className={classnames('centered-cell', _.get(value, 'isNested', false) && 'nested')}
                                >
                                    {_.get(value, 'text', '')}
                                    {_.get(value, 'key', null) === 'MI0001VSSK0102' && (
                                        <Tooltip
                                            id={`business-partners-MI0001VSSK0102-tooltip-${_.get(
                                                value,
                                                'rowIndex',
                                                null
                                            )}`}
                                            content={
                                                <FormattedMessage
                                                    id={`${LOCALE_PREFIX}.tooltipText`}
                                                    values={{
                                                        br: <br />,
                                                        b: (chunks) => <b>{chunks}</b>,
                                                        a: (chunks) => (
                                                            <a
                                                                href="https://rpvs.gov.sk"
                                                                rel="noopener noreferrer"
                                                                target="_blank"
                                                            >
                                                                {chunks}
                                                            </a>
                                                        ),
                                                    }}
                                                />
                                            }
                                            position={POSITION.TOP}
                                            align={ALIGN.CENTER}
                                        >
                                            <div className={'help-icon'} />
                                        </Tooltip>
                                    )}
                                </div>
                            ),
                        },
                        top: {
                            columns: [
                                {
                                    accessor: 'subject',
                                    Cell: (value) => (
                                        <Entity
                                            entity={_.get(value, 'value', null)}
                                            type={_.get(value, 'value.type', null)}
                                            inactive={_.get(value, 'value.inactive', false)}
                                            value={_.get(value, 'value.name', null)}
                                            entId={`${_.get(value, 'value.id', null)}`}
                                            caution={_.get(value, 'value.indicators.caution', null)}
                                            risk={_.get(value, 'value.indicators.risk', null)}
                                            notice={_.get(value, 'value.indicators.notice', null)}
                                        />
                                    ),
                                },
                                {
                                    accessor: 'startDate',
                                    Cell: (value) =>
                                        !_.isNil(_.get(value, 'value.value', null)) && (
                                            <div className={'centered-cell'}>
                                                <span style={{ paddingRight: '4px' }}>
                                                    <FormattedMessage id={`${LOCALE_PREFIX}.from`} />
                                                </span>
                                                <CustomDate
                                                    precision={_.get(value, 'value.precision', null)}
                                                    date={_.get(value, 'value.value', null)}
                                                />
                                            </div>
                                        ),
                                    width: 120,
                                },
                            ],
                        },
                        nested: {
                            visibleRows: (value) => {
                                if (_.get(value, 'tables[0].nested', false)) {
                                    // If there is only one table and it's historical
                                    const tablesRowsLength = _.get(value, 'tables[0].rows', []).length

                                    if (tablesRowsLength > 10) return 10 // Only show 10 rows on first step

                                    return tablesRowsLength // If there is less than 10 rows, show all rows
                                }

                                return 0 // Hide table if there is multiple tables and the first one isn't historical
                            },
                            // eslint-disable-next-line no-confusing-arrow
                            expandText: (value) =>
                                !_.get(value, 'tables[0].nested', false)
                                    ? intl.formatMessage({ id: `${LOCALE_PREFIX}.history` })
                                    : intl.formatMessage({ id: 'global.controlExpand' }),
                            columns: [
                                {
                                    accessor: 'subject',
                                    Cell: (value) => (
                                        <Entity
                                            entity={_.get(value, 'value', null)}
                                            type={_.get(value, 'value.type', null)}
                                            inactive={_.get(value, 'value.inactive', false)}
                                            value={_.get(value, 'value.name', null)}
                                            entId={_.get(value, 'value.id', null)}
                                            caution={_.get(value, 'value.indicators.caution', null)}
                                            risk={_.get(value, 'value.indicators.risk', null)}
                                            notice={_.get(value, 'value.indicators.notice', null)}
                                        />
                                    ),
                                },
                                {
                                    accessor: 'startDate',
                                    Cell: (value) =>
                                        !_.isNil(_.get(value, 'value.value', null)) && (
                                            <div className={'centered-cell nested'}>
                                                <span style={{ paddingRight: '4px' }}>
                                                    <FormattedMessage id={`${LOCALE_PREFIX}.from`} />
                                                </span>
                                                <CustomDate
                                                    precision={_.get(value, 'value.precision', null)}
                                                    date={_.get(value, 'value.value', null)}
                                                />
                                            </div>
                                        ),
                                    width: 120,
                                },
                            ],
                        },
                    }}
                    staticData={data}
                    texts={{
                        loading: intl.formatMessage({ id: 'global.loading' }),
                        noData: intl.formatMessage({ id: 'global.noData' }),
                        controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                        controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                        controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                        controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                        controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                        controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                    }}
                />
            </div>
        )
    }
}
